import React from 'react';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends ClassName, Gap, Layer, TestId {}

/** Renders a horizontal line to visually divide contents with */
const Separator = ({
  className = '',
  gap = 'none',
  layer = 0,
  testId,
}: Props): React.ReactElement => (
  <hr className={`gap--${gap} layer--${layer} ${className} border-gray-300`} data-testid={testId} />
);

export default Separator;
